// extracted by mini-css-extract-plugin
export default {"root":"Sidebar_root__WSO4L","body":"Sidebar_body__wERDy"};